import FundInvestments from './FundInvestments'

export default FundInvestments
